import { render, staticRenderFns } from "./PanelContentItemContentTypeRadio.vue?vue&type=template&id=28c8cb5c&"
import script from "./PanelContentItemContentTypeRadio.vue?vue&type=script&lang=ts&"
export * from "./PanelContentItemContentTypeRadio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
